/**
 * ROT13 Cipher implementation
 * A special case of Caesar cipher with a fixed shift of 13
 */

export const rot13Encrypt = (text) => {
  return text.replace(/[a-zA-Z]/g, (char) => {
    const start = char >= 'A' && char <= 'Z' ? 65 : 97;
    const code = char.charCodeAt(0);
    let shifted = ((code - start + 13) % 26);
    return String.fromCharCode(shifted + start);
  });
};

export const rot13Decrypt = (text) => {
  // ROT13 is its own inverse
  return rot13Encrypt(text);
};

export const rot13Cipher = {
  name: 'ROT13',
  encrypt: rot13Encrypt,
  decrypt: rot13Decrypt,
  requiresKey: false,
  description: 'Rotates each letter by 13 positions (self-inverse)'
};
